import { Component, OnInit } from '@angular/core';
import { NavbarService } from '../_services/site-navbar/navbar.service';
import { FooterService } from '../_services/site-footer/footer.service';
import { Title, Meta } from '@angular/platform-browser';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { IndividualService } from '../individual-programs/individual.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  panelOpenState = false;
  constructor(
    public dialog: MatDialog,
    public nav: NavbarService,
    public footer: FooterService,
    private titleService: Title,
    private metaService: Meta
  ) {}

  public loadJsonLdScript() {
    let node = document.createElement('script');
    node.innerText = JSON.stringify({
      '@context': 'http://schema.org',
      '@type': 'Organization',
      name: 'BANCOM',
      url: 'https://www.bancom.io',
      description:
        'BANCOM, is a multinational technology company which offers help to start and grow career in Salesforce. We offer Industrial training in one of the most popular cloud computing platforms, “Salesforce”. Our tried and true system is based on over 10+ years cumulative experience shared between our trainers. We pride ourselves on setting up our Students/Participants for success in their career and are sure that they will leave our sessions more prepared and confident than they have ever been before.',
      logo: 'https://www.bancom.io/assets/site/icons/logo.svg',
    });
    node.type = 'application/ld+json';
    document.getElementsByTagName('head')[0].appendChild(node);
  }
  openDialog(course: any) {
    const dialogRef = this.dialog.open(DialogsContentDialogComponent, {
      width: '500px',
      data: { course: course },
    });
  }
  openPopup() {
    const dialogRef = this.dialog.open(SelectProgramComponent);

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  ngOnInit(): void {
    this.titleService.setTitle('BANCOM | Boosting Opportunities');
    this.metaService.addTags([
      {
        name: 'keywords',
        content:
          'BANCOM, CSS, JavaScript, APEX, Salesforce, VisualForce, Lightning, LWC, Lightning Web Components ,Resume Builder, Questionnaire App, Salesforce Interview Questions, Salesforce Trainings, 3 Million Jobs, Salesforce Jobs, Salesforce Placements, Salesforce Hiring, Salesforce Internships, Salesforce Trainings, Salesforce Admin, Salesforce Developer, Salesforce Architect, Freshers Jobs, Salesforce Quality Assurance Engineer, Salesforce Business Analyst, Salesforce project Manager ,Salesforce Fresher Training',
      },
      {
        name: 'description',
        content:
          'BANCOM, is a multinational technology company which offers help to start and grow career in Salesforce. We offer Industrial training in one of the most popular cloud computing platforms, “Salesforce”. Our tried and true system is based on over 10+ years cumulative experience shared between our trainers. We pride ourselves on setting up our Students/Participants for success in their career and are sure that they will leave our sessions more prepared and confident than they have ever been before.',
      },
    ]);
    this.loadJsonLdScript();
    this.nav.show();
    this.footer.show();
    // let videos: any = document.getElementsByClassName('video');
    // for (let i = 0; i < videos.length; i++) {
    //   videos[i].muted = true;
    //   videos[i].play();
    // }
  }
}

@Component({
  selector: 'dialog-content-dialog',
  templateUrl: './dialogs-content-dialog.component.html',
})
export class DialogsContentDialogComponent implements OnInit {
  applyNow: FormGroup;
  selected = 'option2';
  constructor(
    private FormBuilder: FormBuilder,
    private IndividualService: IndividualService,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogsContentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public DialogData: any
  ) {
    this.applyNow = this.FormBuilder.group({
      fullName: ['', [Validators.required]],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ],
      phone: [
        '',
        [
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$'),
          Validators.required,
          Validators.minLength(5),
        ],
      ],
      course: ['', [Validators.required]],
    });
  }

  ngOnInit() {
    this.course.setValue(this.DialogData.course);
    console.log(this.DialogData.course);
  }
  get name() {
    return this.applyNow.get('fullName');
  }
  getNameError() {
    if (this.name.hasError('required')) {
      return 'Full Name is required';
    }
  }
  get course() {
    return this.applyNow.get('course');
  }
  get email() {
    return this.applyNow.get('email');
  }
  getEmailError() {
    if (this.email.hasError('pattern')) {
      return 'Invalid Email';
    }
  }
  submitForm() {
    console.log(this.applyNow);
    this.IndividualService.callBackRequest(this.applyNow.value).subscribe(
      (res: any) => {
        if (res.body.success) {
          this._snackBar.open(
            'Be patient, Our concern person will contact you soon',
            'Dismiss',
            {
              duration: 5000,
              panelClass: ['my-snack-bar'],
            }
          );
        } else {
          this._snackBar.open('error', 'Dismiss', { duration: 20000 });
        }
      },
      (err: any) => {
        this._snackBar.open(err, 'Dismiss', { duration: 20000 });
      }
    );
  }
}

@Component({
  selector: 'selectProgram',
  templateUrl: './selectProgram.component.html',
})
export class SelectProgramComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogsContentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  closePopup() {
    this.dialogRef.close();
  }
}
